import { render, staticRenderFns } from "./SidePanelProjects.vue?vue&type=template&id=5e158418&scoped=true&"
import script from "./SidePanelProjects.vue?vue&type=script&lang=js&"
export * from "./SidePanelProjects.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelProjects.vue?vue&type=style&index=0&id=5e158418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e158418",
  null
  
)

export default component.exports